/* eslint-disable max-len */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { selectDeductible } from '../../../../actions/quote';
import icContado from '../../../../../../assets/images/deductible/ic_cotizacion_contado.svg';
import icDebito from '../../../../../../assets/images/deductible/ic_cotizacion_debito.svg';
import icDiferido from '../../../../../../assets/images/deductible/ic_cotizacion_diferido.svg';
import icTarjeta from '../../../../../../assets/images/deductible/ic_cotizacion_tarjeta.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 140,
    borderRadius: '10px',
    backgroundColor: '#518CBF',
    marginLeft: 10,
    marginRight: 10,
    [theme.breakpoints.down(450)]: {
      marginRight: '5px !important',
      width: 130,
    },
  },
  textColor: {
    color: theme.palette.primary.light,
  },
  listItem: {
    justifyContent: 'flex-end',
  },
  listItemSelect: {
    justifyContent: 'flex-end',
    '&:hover': {
      background: '#2B6B96',
    },
    '&.Mui-selected': {
      backgroundColor: '#06466E',
    },
  },
  selectedDeductible: {
    backgroundColor: '#17598E',
  },
}));

const paymentTypeIcons = {
  Contado: icContado,
  'Débito Bancario': icDebito,
  'Diferido Especial': icDiferido,
  'Tarjeta de Crédito': icTarjeta,
};

const getIcon = (typeDescription) => {
  const title = paymentTypeIcons[typeDescription] ? typeDescription : 'Contado';
  return (
    <Tooltip title={title}>
      <img
        src={paymentTypeIcons[title]}
        alt={title}
      />
    </Tooltip>
  );
};

export default function Deductible({ detail }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const quote = useSelector((state) => state.quote);

  const { deductibleSelected } = quote;

  const dispatchSelectDeductible = (paymentType) => {
    dispatch(selectDeductible(detail, paymentType));
  };

  return (
    <Card
      style={{ marginRight: 40 }}
      className={clsx(
        classes.root,
        detail.deductibleId === deductibleSelected?.deductible?.deductibleId && classes.selectedDeductible,
      )}
    >
      <List>
        <ListItem className={classes.listItem}>
          <Typography variant="h1" className={classes.textColor}>
            {detail?.productDescription}
          </Typography>
        </ListItem>
        {detail?.paymentType.map((payment) => (
          <ListItem
            key={payment?.typeId}
            button
            className={classes.listItemSelect}
            selected={deductibleSelected?.quotationId.toString().concat(`${deductibleSelected.paymentType}`)
            === payment?.quotationId.toString().concat(`${payment?.typeDescription}`)}
            onClick={() => dispatchSelectDeductible(payment)}
          >
            <ListItemIcon style={{ minWidth: '40px' }}>
              {getIcon(payment?.typeDescription)}
            </ListItemIcon>
            <ListItemText primary={
              (
                <Typography className={classes.textColor}>
                  {`$${payment?.value}`}
                </Typography>
              )
            }
            />
          </ListItem>
        ))}
      </List>
    </Card>
  );
}

Deductible.propTypes = {
  detail: PropTypes.shape({
    deductibleId: PropTypes.number.isRequired,
    productDescription: PropTypes.string.isRequired,
    paymentType: PropTypes.arrayOf(
      PropTypes.shape({
        typeId: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
      }),
    ),
  }).isRequired,
};
